import { XMarkIcon } from "@heroicons/react/24/outline";
import {
    Dialog,
    DialogPanel,
    DialogTitle,
} from "lib/headlessui/components/dialog/dialog";
import {
    Transition,
    TransitionChild,
} from "lib/headlessui/components/transition/transition";
import React from "react";

interface Props {
    isOpen: boolean;
    headerText?: string;
    hasCloseButton?: boolean;
    onDismiss?: () => void;
    children: React.ReactNode;
}

const emptyCallback: () => void = () => {};

export const Modal: React.FC<Props> = props => {
    const { isOpen, headerText, onDismiss, hasCloseButton } = props;
    const realOnDismiss = onDismiss ?? emptyCallback;
    const showCloseButton = hasCloseButton === false ? false : true;
    return (
        <Transition appear={true} show={isOpen}>
            <Dialog as="div" className="relative z-1500" onClose={realOnDismiss}>
                <TransitionChild
                    enter="ease-in-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in-out duration-500"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0">
                    <div className="fixed inset-0 bg-gray-500/75 transition-opacity" />
                </TransitionChild>

                <div className="fixed inset-0 overflow-hidden">
                    <div className="absolute inset-0 overflow-hidden">
                        <div className="pointer-events-none fixed inset-y-0 right-0 left-0 flex max-w-full">
                            <TransitionChild
                                enter="ease-out duration-300"
                                enterFrom="opacity-0 scale-95"
                                enterTo="opacity-100 scale-100"
                                leave="ease-in duration-200"
                                leaveFrom="opacity-100 scale-100"
                                leaveTo="opacity-0 scale-95">
                                <DialogPanel className="pointer-events-auto w-full transform overflow-hidden bg-white text-left align-middle transition-all p-2 md:p-6 md:m-6 md:rounded-2xl md:shadow-xl">
                                    <div className="flex h-full flex-col overflow-y-scroll bg-white">
                                        <div className="px-4 sm:px-6">
                                            <div className="flex items-start justify-between">
                                                <DialogTitle className="text-lg font-medium text-gray-900">
                                                    {headerText ?? ""}
                                                </DialogTitle>
                                                <div className="ml-3 flex h-7 items-center">
                                                    {showCloseButton ? (
                                                        <button
                                                            type="button"
                                                            className="rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-brand-500"
                                                            onClick={realOnDismiss}>
                                                            <span className="sr-only">
                                                                Close panel
                                                            </span>
                                                            <XMarkIcon
                                                                className="h-6 w-6"
                                                                aria-hidden="true"
                                                            />
                                                        </button>
                                                    ) : null}
                                                </div>
                                            </div>
                                        </div>
                                        <div className="relative mt-6 flex-1 px-4 sm:px-6">
                                            <div className="app-component">
                                                <div className="panel-body">
                                                    {props.children}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </DialogPanel>
                            </TransitionChild>
                        </div>
                    </div>
                </div>
            </Dialog>
        </Transition>
    );
};
